import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import React from "react";
import {
  BreadCrumbProp,
  BreadCrumb,
} from "../../../components/light/Breadcrumb";
import { Content } from "../../../components/light/Content";
import { SectionBlock } from "../../../components/light/SectionBlock";
import { Loading } from "../../../components/Loading";
import { useTranslation } from "react-i18next";
import { Button, IndexTable, LegacyCard, Page } from "@shopify/polaris";
import { PolarisEmptyState } from "src/components/shopify/PolarisEmptyState";

const QUERY = gql`
  query supplierVendorList {
    supplierVendorList {
      id
      name
      contactInfo
      address
      note
      margin
    }
  }
`;

const BreadCrumbItems: BreadCrumbProp[] = [
  { text: "options", to: "#" },
  { text: "vendors", to: "/options/vendor/list" },
];

const formatData = [
  {
    displayName: "name",
    fieldMatch: "name",
    className: "",
  },
  {
    displayName: "contact",
    fieldMatch: "contactInfo",
    className: "",
  },
  {
    displayName: "address",
    fieldMatch: "address",
    className: "",
  },
  {
    displayName: "note",
    fieldMatch: "note",
    className: "",
  },
  {
    displayName: "action",
    fieldMatch: "id",
    className: "text-center",
    customeField: true,
  },
]

export function VendorListScreen(props: any) {
  const { t } = useTranslation();
  const { data, loading } = useQuery(QUERY);

  if (loading || !data) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <SectionBlock title="Vendor">
          <Loading />
        </SectionBlock>
      </Content>
    );
  }

  return (
    <Page title={t('vendor')} primaryAction={{ content: t('create'), url: '/options/vendor/create' }}>
      <LegacyCard>
        <LegacyCard.Section flush>
          <IndexTable headings={formatData.map(x => {
            return { title: t(x.displayName) }
          }) as any} loading={loading} itemCount={data.supplierVendorList.length} selectable={false} emptyState={<PolarisEmptyState />}>
            {
              data.supplierVendorList.map((x: any, i: any) => {
                return (
                  <IndexTable.Row key={i} id={i + 1} position={i}>
                    <IndexTable.Cell>
                      <small>{x.name}</small>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                      <small>{x.contactInfo}</small>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                      <small>{x.address}</small>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                      <small>{x.note}</small>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                      <Button
                        url={`/options/vendor/edit/${x.id}`}
                        size="slim"
                      >
                        {t('edit')}
                      </Button>
                    </IndexTable.Cell>
                  </IndexTable.Row>
                )
              })
            }
          </IndexTable>
        </LegacyCard.Section>
      </LegacyCard>
    </Page>
  );
}
